const utilValidations = () => {
    const parseServerErrorResponse = (response: any): string[] => {
        if (response?.data?.error) {
            return response.data.error.map((err: any) => err.message);
        }
            return ["An unknown error occurred."];
    };

    const formValidateField = (name: string, value: string): string | undefined => {
            switch (name) {
            // case "salutation":
            //     return value!=="-" && value !==""? undefined : "Salutation is required.";
            case "first_name":
                return value.length>2 ? undefined : "First name must be of Length 3 or higher";
            // case "last_name":
            //     return value.length>2 ? undefined : "Last name must be of Length 3 or higher.";
            
            // case "company_name":
            //     return value.length>2 ? undefined : "Company name must be of Length 3 or higher.";
            
            // case "job_title":
                // return value.length>2 ? undefined : "Job title must be of Length 3 or higher.";
            
            case "email":
                return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)
                ? undefined
                : "Please enter a valid email address.";
            case "password":
                // const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
                // return passwordRegex.test(value)
                return value.length>8
                ? undefined
                : "Minimum eight characters, at least one uppercase letter, one lowercase letter, one number and one special character";
            // case "Phone":
            //     return /^\d{10,15}$/.test(value)
            //     ? undefined
            //     : "Phone number must be between 10 and 15 digits.";

            // case "country_code":
            //     return value ? undefined : "Please select an country.";

            case "acceptance":
                return value === "true" ? undefined : "You must accept the privacy policy.";

            default:
                return undefined;
        }
            

    }

    

  return { parseServerErrorResponse,formValidateField};
};

export default utilValidations;

interface FormDataType {
    facebook_profile?: string;
    twitter_profile?: string;
    linkedin_profile?: string;
    portfolio_link?: string;
  }

export const validateProfileLinks = (formData: FormDataType): { [key: string]: string } => {
    const newErrors: { [key: string]: string } = {};
  
    const urlPattern = /^https?:\/\/\S+$/;
  
    if (formData.facebook_profile && !urlPattern.test(formData.facebook_profile)) {
      newErrors.facebook_profile = "Facebook link must be a valid URL";
    }
    if (formData.twitter_profile && !urlPattern.test(formData.twitter_profile)) {
      newErrors.twitter_profile = "Twitter link must be a valid URL";
    }
    if (formData.linkedin_profile && !urlPattern.test(formData.linkedin_profile)) {
      newErrors.linkedin_profile = "LinkedIn link must be a valid URL";
    }
    if (formData.portfolio_link && !urlPattern.test(formData.portfolio_link)) {
      newErrors.portfolio_link = "Portfolio link must be a valid URL";
    }
  
    return newErrors;
  };

  export const validatePassword = (password: string): string | undefined => {
    const strongPasswordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
  
    if (!password) return "Password is required.";
  
    if (!strongPasswordRegex.test(password)) {
      return "Password must be at least 8 characters, include one uppercase letter, one lowercase letter, one number, and one special character.";
    }
    return undefined; // valid password
  };
  
